import { render, staticRenderFns } from "./QuestionHistory.vue?vue&type=template&id=900a27a4"
import script from "./QuestionHistory.vue?vue&type=script&lang=js"
export * from "./QuestionHistory.vue?vue&type=script&lang=js"
import style0 from "./QuestionHistory.vue?vue&type=style&index=0&id=900a27a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports